export default __webpack_public_path__ + "static/media/outfit-paul-smith.29579ef8.jpg";